<template>
	<div>
		<header>
			<h1>Invoices</h1>
		</header>
		<div>
			<div v-if="!loaded" class="section">
				<loader v-if="!loaded"/>
			</div>
			<template v-if="loaded">
				<div class="sections sections--flexed">
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Outstanding </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="$present('price', stats.outstanding)"></span>
						</p>
					</section>
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Paid </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="$present('price', stats.paid)"></span>
						</p>
					</section>
				</div>
				<div class="section">
					<table-filter :filters="filters"/>
					<div v-if="!items.length" class="nothing-to-see-here">
						<p>Nothing to display.</p>
					</div>
					<table v-if="items.length" role="grid">
						<thead>
							<tr>
								<th align="left">For</th>
								<th align="left">ID</th>
								<th align="left">Value</th>
								<th align="center">Status</th>
							</tr>
						</thead>
						<tfoot>
							<tr>
								<th align="left">For</th>
								<th align="left">ID</th>
								<th align="left">Value</th>
								<th align="center">Status</th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="(item, index) in items">
								<td v-html="item.cause.type"/>
								<td v-if="!$can('view', item.cause)" v-html="item.cause.id"/>
								<td v-if="$can('view', item.cause)">
									<router-link
										:to="{name: 'instructions.show', params: {instruction: item.cause.id}}"
										v-html="item.cause.id"/>
								</td>
								<td v-html="$present('price', item.value)"/>
								<td align="center">
									<status-badge :status="item.status" group="invoice"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions} = createNamespacedHelpers("invoices");

export default {

	data() {
		return {};
	},

	computed: {
		...mapState([
			"columns",
			"items",
			"links",
			"loaded",
			"gettingModels",
			"meta",
			"stats",
			"query",
			"filters",
		]),
	},

	methods: {
		...mapActions([
			"getModels",
			"goToPage",
			"paginate",
			"filter",
		]),
	},

	created() {
		this.getModels();
	},
};
</script>
